import { render, staticRenderFns } from "./PanelEmpleados.vue?vue&type=template&id=a4611caa&scoped=true"
import script from "./PanelEmpleados.vue?vue&type=script&lang=js"
export * from "./PanelEmpleados.vue?vue&type=script&lang=js"
import style0 from "./PanelEmpleados.vue?vue&type=style&index=0&id=a4611caa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4611caa",
  null
  
)

export default component.exports